export default __webpack_public_path__ + "static/media/header.5b3ce75b.jpg";